import React, { useEffect, useState, useContext } from "react";
import axios from "axios";

import SearchContext from "contexts/SearchContext";
import RecipeCard from "components/RecipeCard";
import PageNumbers from "components/PageNumbers";

import Container from "@mui/material/Container";
import Grid from "@mui/material/Unstable_Grid2";

function RecipeResults() {
  // "contextSearchValue" variable used to consume/use Search context
  const [contextSearchValue, setContextSearchValue] = useContext(SearchContext);

  // Define initial state
  const [recipeData, setRecipeData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [resultsPerPage, setResultsPerPage] = useState(6);
  
  /**
    * query value is set by contextSearchValue (which is obtained from Search context, which is updated by the input value of the search bar)
    * if query is empty (no input value from search bar), then Home page version displayed (all recipes)
    * if query is not empty (value coming from search bar), then Search Results page version displayed (recipes from search results)
  **/
  const query = contextSearchValue;
  
  useEffect(() => {
    // Get all recipes from Express server
    const getRecipeData = async function() {
      await axios.get("/food-recipe-react/api/recipes")
        .then(response => {
          setRecipeData(response.data);
        })
        .catch(error => {
          console.log(error);
        });
    };

    // Search recipes from Express server
    const searchRecipes = async function(q) {
      await axios.get("/food-recipe-react/api/search?q=" + q)
        .then(response => {
          setRecipeData(response.data);
        })
        .catch(error => {
          console.log(error);
        });
    };
    
    if (query === "") { // if no search query exists, then display all recipes on Home page
      getRecipeData();
    } else { // if search query exists, then display search results
      searchRecipes(query);
    }
    
    window.scrollTo(0, 0); // scroll to top of page on page load
  }, [query]);

  // "recipes" is an array of results in the API so "recipeData.recipes" is used to access it
  const recipes = recipeData.recipes;

  const totalResults = (recipes) ? recipes.length : "";
  const totalPages = Math.ceil(totalResults / resultsPerPage);
  const indexEndResult = currentPage * resultsPerPage;
  const indexStartResult = indexEndResult - resultsPerPage;
  const currentResults = (recipes) ? recipes.slice(indexStartResult, indexEndResult) : "";
  
  const paginate = function(pageNumber) {
    setCurrentPage(pageNumber);
    window.scrollTo(0, 0); // scroll to top of page after page change
  };

  return (
    <>
      <Container maxWidth="lg">
        {(query !== "") && recipes &&
          <>
            {(recipes.length > 0) ? "Search results for " : "No results for "}
              <strong>{query}</strong>
          </>
        }
        <Grid container sx={{ my: 1 }} spacing={3}>
          {recipes && currentResults.map(function(recipe) {
            return (
              <>
                <Grid xs={12} sm={6} md={4} lg={4}>
                  {/* RecipeCard component */}
                  <RecipeCard key={recipe.id} recipe={recipe} />
                </Grid>
              </>
            );
          })}
        </Grid>
        {/* PageNumbers component */}
        <PageNumbers totalPages={totalPages} paginate={paginate} />
      </Container>
    </>
  );
}

export default RecipeResults;